// @core/api/endpoints/document/move_block.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BlockResponse,
  MoveBlockRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Move block
 * Moves a block to a new position. Can reorder among siblings or reparent to a different block. Position is auto-calculated using fractional indexing.
 */
export async function MoveBlock(
  document_id: string,
  block_id: string,
  data: MoveBlockRequest,
  options?: RequestOptions
): Promise<BlockResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/blocks/:block_id/move`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  requestPath = requestPath.replace(':block_id', encodeURIComponent(block_id));
  const requestOptions = options;
  return client.post<BlockResponse>(requestPath, data, requestOptions);
}
